import { HttpEvent, HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, take, tap, throwError } from 'rxjs';

import { getToken } from '../../modules/auth/state/auth.state';
import { FeUtil, ExceptionHandlerService } from '../../hezky-routes';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const feUtil = inject(FeUtil);
  const exceptionHandler = inject(ExceptionHandlerService);
  const applications = feUtil?.applications;
  const customerId = feUtil?.user_data?.customer?.customer_id;
  const userId = feUtil?.user_data?.user_id;
  const locationIds = feUtil?.nLevelPayload?.location_id;

  feUtil.store.select(getToken).pipe(take(1)).subscribe({
    next: (token) => {
      let application_id!: string;
      let locStrSelectedApp = localStorage.getItem('selectedApplication');
      if (locStrSelectedApp) {
        const selectedApp = JSON.parse(locStrSelectedApp);
        if (selectedApp.application_id == 0 || selectedApp.application_id == 3 || req.url.includes('/notification') || req.url.includes('/environment')) {
          application_id = applications?.map((app: { id: number }) => app.id).filter(id => feUtil.user_data.application_id.some(app => app.id === id)).join(',');
        } else {
          application_id = selectedApp.application_id.toString();
        }
      } else {
        application_id = applications?.map((app: { id: number }) => app.id).filter(id => feUtil.user_data?.application_id?.some((app: { id: number }) => app.id === id)).join(',');
      }
      if (token && application_id && locationIds && customerId) {
        const newHeaders = {
          Authorization: `Bearer ${token}`,
          'x-customer-id': String(customerId),
          'x-user-id': String(userId),
          'x-app-ids': req.headers.get('x-app-ids') || application_id,
          'x-locations': locationIds.join(',')
        }
        req = req.clone({
          setHeaders: newHeaders,
        });
      }
    }
  });

  return next(req).pipe(
    tap((event: HttpEvent<any>) => {
      if (event.type === HttpEventType.Response) {
        exceptionHandler.handleHttpError(event.body, req.body);
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if(error.status === 0) {
        feUtil.message.error('Server is down or unreachable.');
      }
      if (error.status == 429) {
        feUtil.message.error(error.error.message)
      }
      if (error.status == 401 || error.status == 403) exceptionHandler.handleAuthError();
      return throwError(() => error);
    })
  );
};
